import { render, staticRenderFns } from "./CardDurationProject.vue?vue&type=template&id=3694ebfe&scoped=true"
import script from "./CardDurationProject.vue?vue&type=script&lang=js"
export * from "./CardDurationProject.vue?vue&type=script&lang=js"
import style0 from "./CardDurationProject.vue?vue&type=style&index=0&id=3694ebfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694ebfe",
  null
  
)

export default component.exports